import {
  faCashRegister,
  faClock,
  faGlobe,
  faHome,
  faLocationDot,
  faSackDollar,
  faUserTie,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { ClientPage } from 'pages/Database/Clients/ClientPage';
import { CoachPage } from 'pages/Database/Coaches/CoachPage';
import { GroupPage } from 'pages/Database/Groups/GroupPage';
import { CashboxPage } from 'pages/Cashboxes/CashboxPage';
import { Locations } from 'pages/Locations/Locations';
import { CashRegister } from 'pages/CashRegister';
import { Coaches } from 'pages/Database/Coaches';
import { Clients } from 'pages/Database/Clients';
import { UserPage } from 'pages/Users/UserPage';
import { Groups } from 'pages/Database/Groups';
import { Cashboxes } from 'pages/Cashboxes';
import { Dashboard } from 'pages/Dashboard';
import { Database } from 'pages/Database';
import { Schedule } from 'pages/Schedule';
import { Users } from 'pages/Users';

export const routes = [
  {
    key: 'dashboard',
    title: 'Панель керування',
    path: '/panel',
    icon: faHome,
    component: Dashboard,
  },
  {
    key: 'schedule',
    title: 'Записи',
    path: '/schedule',
    icon: faClock,
    component: Schedule,
  },
  {
    key: 'cashRegister',
    title: 'Каса',
    path: '/cash-register',
    icon: faCashRegister,
    component: CashRegister,
  },
  {
    key: 'database',
    title: 'База даних',
    path: '/database',
    icon: faUsers,
    component: Database,
  },
  {
    key: 'clients',
    title: 'Клієнти',
    path: '/database/clients',
    component: Clients,
    hideInMenu: true,
  },
  {
    key: 'clientPage',
    title: 'Клієнти',
    path: '/database/clients/:clientID',
    component: ClientPage,
    hideInMenu: true,
  },
  {
    key: 'coaches',
    title: 'Тренери',
    path: '/database/coaches',
    component: Coaches,
    hideInMenu: true,
  },
  {
    key: 'coachPage',
    path: '/database/coaches/:coachID',
    component: CoachPage,
    hideInMenu: true,
  },
  {
    key: 'groups',
    title: 'Групи',
    path: '/database/groups',
    component: Groups,
    hideInMenu: true,
  },
  {
    key: 'groupPage',
    path: '/database/groups/:groupID',
    component: GroupPage,
    hideInMenu: true,
  },
  {
    key: 'cashboxes',
    title: 'Фінанси',
    path: '/finance',
    icon: faSackDollar,
    component: Cashboxes,
  },
  {
    key: 'cashboxPage',
    path: '/finance/:cashboxID',
    component: CashboxPage,
    hideInMenu: true,
  },
  {
    key: 'locations',
    title: 'Локації',
    path: '/locations',
    icon: faLocationDot,
    component: Locations,
  },
  {
    key: 'users',
    title: 'Персонал',
    path: '/users',
    icon: faUserTie,
    component: Users,
  },
  {
    key: 'users',
    path: '/users/:userID',
    component: UserPage,
    hideInMenu: true,
  },
];
